import request from '../utils/http'
// 激活码列表
export function index (query) {
  return request({
    url: '/activeCode/list',
    method: 'GET',
    params: query
  })
}
// 新增激活码
export function save (query) {
  return request({
    url: '/activeCode/save',
    method: 'POST',
    data: query
  })
}
// 批量新增激活码
export function batch (query) {
  return request({
    url: '/activeCode/batch',
    method: 'POST',
    data: query
  })
}
// 编辑激活码
export function edit (query) {
  return request({
    url: '/activeCode/edit',
    method: 'GET',
    params: query
  })
}
// 更新激活码
export function update (query) {
  return request({
    url: '/activeCode/update',
    method: 'POST',
    data: query
  })
}
// 删除激活码
export function del (query) {
  return request({
    url: '/activeCode/delete',
    method: 'DELETE',
    data: query
  })
}
// 激活码开关
export function show (query) {
  return request({
    url: '/activeCode/show',
    method: 'POST',
    data: query
  })
}
// 导出激活码
export function activeCodeExport (query) {
  return request({
    url: '/activeCode/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/activeCode.js